import { DateField, TextField } from '@servicetitan/anvil2-react-hook-form';

interface VisaFieldsProps {
    fieldPrefix?: string;
}

export const VisaFields = ({ fieldPrefix = '' }: VisaFieldsProps) => {
    return (
        <>
            <TextField
                label="ID Number"
                name={[fieldPrefix, 'applicantId.documentId'].join('.')}
                required
            />
            <DateField
                label="Issue Date"
                name={[fieldPrefix, 'applicantId.issueDate'].join('.')}
                required
            />
            <DateField
                label="Expiration Date"
                name={[fieldPrefix, 'applicantId.expirationDate'].join('.')}
                required
            />
            <TextField
                label="Government Branch"
                name={[fieldPrefix, 'applicantId.governmentBranch'].join('.')}
                required
            />
        </>
    );
};
